import React from "react";
import styled from "styled-components";
import { Trans } from "@coworker/locales";
import { NativeNumberKeyPad } from "./NativeNumberKeyPad";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import FixaInlineMessage from "@coworker/apprestructured/src/shared/wrappers/FixaInlineMessage/FixaInlineMessage";
import { RegexOptions } from "./shared/RegexOptions";

const Container = styled("div")`
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100% - 50px);
  width: 100%;
  top: 0;
  left: 0;
  background: var(--white);
  margin-top: 10px;
  overflow-y: auto;
`;
const Title = styled("h1")`
  font-size: 28px;
  font-weight: bold;
  color: var(--grey900);
  margin: 55px 29px;
  margin-bottom: 0px;
`;

const InputWrapper = styled("div")`
  margin: 10px 40px 10px 29px;
`;

const ErrorInfo = styled("div")`
  font-size: 12px;
  color: var(--grey600);
  margin-bottom: 12px;
  margin-top: 10px;
  min-height: 45px;
  display: flex;
  align-items: center;
`;

const ButtonWrapper = styled("div")`
  margin-top: 5px;
`;

const Number = ({ value, bigTitle, instruction, onSubmit, maxLength = 6 }) => {
  const [chosen, setChosen] = React.useState(value || "");
  const [showError, setShowError] = React.useState(false);
  const containerRef = React.useRef(null);

  const validateDate = (value) => {
    const regex =
      /^(?:\d{2}([0-4]\d|5[0-3])|(?:\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])))$/;

    return regex.test(value);
  };

  const handleSubmit = () => {
    if (validateDate(chosen)) {
      onSubmit(chosen);
    } else {
      setShowError(true);
    }
  };

  return (
    <Container ref={containerRef} data-testid="dateStampModal">
      <Title>{bigTitle}</Title>
      <InputWrapper>
        <NativeNumberKeyPad
          disabled={false}
          initialValue={chosen}
          inputMode="numeric"
          keypadType="number"
          onUpdate={(value) => setChosen(value)}
          onComplete={handleSubmit}
          maxLength={maxLength}
          regexOptions={RegexOptions.ONLYNUMBERS}
        />
        <ErrorInfo>
          {showError && (
            <FixaInlineMessage
              body={"Invalid date format. Please use YYMM or YYMMDD."}
              variant="negative"
              subtle
            />
          )}
        </ErrorInfo>
        <ButtonWrapper>
          <FixaButton onClick={handleSubmit} type="primary" fluid>
            <Trans>submitString</Trans>
          </FixaButton>
        </ButtonWrapper>
      </InputWrapper>
      {instruction}
    </Container>
  );
};

export default Number;
